module.exports = __webpack_public_path__ + "static/media/ccl-org.73f609e4.png";